<template>
    <div>

        <div class="content-caption dashed">
            <span>资产</span>
        </div>
        <div class="simple-form col-2 flex label">
            <div class="form-group center">
                <div class="form-label">
                    <label>资产名称</label>
                </div>
                <div class="form-value">
                    <span>{{deviceMaintPlan.deviceName}}</span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>资产子号</label>
                </div>
                <div class="form-value">
                    <span>{{deviceMaintPlan.deviceSubNo}}</span>
                </div>
            </div>
        </div>
        <div class="content-caption dashed">
            <span>服务</span>
        </div>
        <div class="simple-form label">
            <div class="form-group center">
                <div class="form-label">
                    <label>服务名称</label>
                </div>
                <div class="form-value">
                    <span>{{deviceMaintPlan.servcTitle}}</span>
                </div>
            </div>
        </div>
        <div class="content-caption dashed">设置</div>
        <div class="simple-form">
            <div class="form-group center">
                <div class="form-label">
                    <label class="required">选择日期</label>
                </div>
                <div class="form-value">
                    <el-date-picker v-model="deviceMaintPlan.theDate" :disabled="disabledFlag" type="date" placeholder="选择日期" :picker-options="pickerOptions0"></el-date-picker>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label class="required">选择时间</label>
                </div>
                <div class="form-value">
                    <el-time-picker v-model="deviceMaintPlan.theTime" :disabled="disabledFlag" placeholder="任意时间点"></el-time-picker>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label class="required">自动创建请求单</label>
                </div>
                <div class="form-value">
                    <el-radio-group disabled v-model="deviceMaintPlan.autoRequst">
                        <el-radio :label="false">否</el-radio>
                        <el-radio :label="true">是</el-radio>
                    </el-radio-group>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label class="required">是否cron表达式</label>
                </div>
                <div class="form-value">
                    <el-radio-group disabled v-model="deviceMaintPlan.cronFlag">
                        <el-radio :label="false">否</el-radio>
                        <el-radio :label="true">是</el-radio>
                    </el-radio-group>
                </div>
            </div>
            <div class="form-group center" v-if="cronFlag">
                <div class="form-label">
                    <label>cron表达式</label>
                </div>
                <div class="form-value">
                    <el-input type="text" disabled v-model="deviceMaintPlan.theExpr"></el-input>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

    import { Utils } from '../../app.base'
    import { Vue, MsgBox, Routes } from '../../app.vues'
    //
    import shopDevcApi from '../../api/shopDevc'
    import devcApi from '../../api/devc'

    //
    export default {
        name: 'swb-device-maint-plan-edit',
        path: '',
        avlScopes: 'retailer',
        desc: '编辑门店资产保养',
        props: {
            id: {
                type: Number
            }
        },
        data: function () {
            return {
                deviceMaintPlan: {
                    theDate: null,
                    theTime: null
                },
                pickerOptions0: {
                    disabledDate(time) {
                        return time.getTime() < Date.now() - 8.64e7;
                    }
                },
                disabledFlag: false,
                cronFlag: false
            }
        },
        created: function () {
            this.getDeviceMaintPlan();
        },
        methods: {
            // 获取设备保养计划详情
            getDeviceMaintPlan: function () {
                let self = this;
                let postData = {
                    id: self.id
                };
                devcApi.getDeviceMaintPlanDetail(postData, function (result) {
                    if(result.type == 'info') {
                        self.deviceMaintPlan = result.data;
                        let theDate = self.deviceMaintPlan.theDate;
                        let theTime = self.deviceMaintPlan.theTime;
                        self.deviceMaintPlan.theTime = new Date(theDate + ' ' + theTime);
                        self.cronFlag = self.deviceMaintPlan.cronFlag;
                        if(self.deviceMaintPlan != null && self.deviceMaintPlan.reqVoucherId != null) {
                            self.disabledFlag = true;
                        }
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            // 保存设备保养计划
            getDlgResult: function () {
                let result = {};
                if(Utils.isNoB(this.deviceMaintPlan.theDate)) {
                    result.type = 'warn';
                    result.message = '请选择日期！';
                } else if(Utils.isNoB(this.deviceMaintPlan.theTime)) {
                    result.type = 'warn';
                    result.message = '请选择时间！';
                } else {
                    result.type = 'info';
                    result.data = {
                        theDate: this.deviceMaintPlan.theDate.format("yyyy-MM-dd"),
                        theTime: this.deviceMaintPlan.theTime.format("HH:mm:ss")
                    };
                }
                //
                return result;
            }
        }
    }

</script>



// WEBPACK FOOTER //
// src/compo/retailer/DeviceMaintPlanEdit.vue